<template>
  <div
    class="mx-auto mb-[3.25rem]"
    style="max-width: 780px"
  >
    <a
      href="https://loan.edu-care.co.jp/index8bx12nwgys6n5v27mh34.html"
      target="_blank"
      class="te-educare-5000 hover:opacity-80"
    >
      <img
        class="mx-auto sm:hidden"
        src="~/assets/images/Te/TeCommon/Banner/Educare/educare-5000-sp.svg"
        alt="EduCareローンバナー"
        loading="lazy"
        width="335"
        height="325"
      >
      <img
        class="hidden w-full sm:block"
        src="~/assets/images/Te/TeCommon/Banner/Educare/educare-5000-pc.svg"
        alt="EduCareローンバナー"
        loading="lazy"
        width="780"
        height="166"
      >
    </a>
    <div class="co-display-14 mx-auto mt-2 max-w-[335px] leading-tight text-co-gray-500 sm:max-w-none">
      <div>※ 20万円お借入で金利5%の場合。</div>
      <div class="mt-2">
        本バナー広告は、株式会社EduCareによるものです。これより先はEduCareのウェブサイトにリンクします。
      </div>
    </div>
  </div>
</template>
